import { Stack, Typography } from '@mui/material';
import { PieChart, Pie, Legend, Tooltip } from 'recharts';
import PropTypes from 'prop-types';
import { useResponsive } from 'src/hooks/use-responsive';

const data = [
  { name: 'Web and mobile development', value: 2, fill: '#002D69' },
  { name: 'MERN stack development', value: 3, fill: '#212121' },
  { name: 'Data Analysis', value: 5, fill: '#3357FF' },
  { name: 'Communication', value: 2, fill: '#383838' },
];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = props => {
  const { value, cx, cy, midAngle, innerRadius, outerRadius, percent, index } =
    props;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN) + 25;
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${value} years`}
    </text>
  );
};

export default function DomainPieChart({ chartData }) {
  const mdUp = useResponsive('up', 'md');

  return (
    <Stack sx={{ marginTop: '-10px' }}>
      <PieChart width={mdUp ? 720 : 320} height={mdUp ? 400 : 260}>
        <Pie
          dataKey="value"
          data={chartData}
          cx={mdUp ? 200 : 80}
          cy={mdUp ? 200 : 120}
          outerRadius={mdUp ? 130 : 70}
          fill="#8884d8"
          labelLine={false}
          label={renderCustomizedLabel}
          stroke="none"
        />
        <Legend
          align="right"
          verticalAlign="middle"
          layout="vertical"
          formatter={(value, entry) => (
            <Typography
              varaint={mdUp ? 'input' : 'caption'}
              sx={{
                color: entry.color,
                marginLeft: { xs: '8px', md: '10px' },
                fontSize: { xs: '11px', md: '14px' },
                display: 'inline-block',
              }}
            >
              {value}
            </Typography>
          )}
          // margin={{ top: 10, right: 30, bottom: 10, left: 0 }}
        />
        <Tooltip />
      </PieChart>
      <style>
        {`
          .recharts-legend-item {
            margin-bottom: 15px; /* Adjust the margin as needed */
          }
        `}
      </style>
    </Stack>
  );
}

DomainPieChart.propTypes = {
  chartData: PropTypes.array.isRequired,
};
